import React, { StrictMode, useEffect } from "react";
import { hot } from "react-hot-loader/root";
import { Meta } from "@sicredi/react";
import { Routes } from "#/routes";
import { useOidc, useOidcAccessToken } from "@axa-fr/react-oidc";
import { ContextProver } from "./contextProver/ContextProver";

export const App: React.FC = () => {
  const { accessToken, accessTokenPayload } = useOidcAccessToken();
  const { logout } = useOidc();

  useEffect(() => {
    window.auth = {
      ...window.auth,
      user: accessTokenPayload,
      get token() {
        return accessToken;
      },
    };
  }, [accessToken, accessTokenPayload]);

  useEffect(() => {
    window.auth = {
      ...window.auth,
      actions: { logout },
    };
  }, [logout]);

  return (
    <>
      <Meta titleTemplate="%s - Sicredi" defaultTitle="Sicredi" />

      <main>
        <StrictMode>
          <ContextProver>
            <Routes />
          </ContextProver>
        </StrictMode>
      </main>
    </>
  );
};

export default hot(App);
